module.exports = __webpack_public_path__ + "static/media/img95.5aac23e9.jpg";